import { api } from './client.js';

export type AuthUser = {
  id: string;
  email: string;
  role: 'reception' | 'housekeeping' | 'owner' | 'admin';
  tenantId: string;
  username?: string | null;
  displayName?: string | null;
  initials?: string | null;
};

export type LoginInput = { email: string; password: string };

export async function login(input: LoginInput): Promise<{ ok: true; user: AuthUser }> {
  return api('/auth/login', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function logout(): Promise<{ ok: true }> {
  return api('/auth/logout', { method: 'POST' });
}

export async function me(): Promise<{ user: AuthUser }> {
  return api('/auth/me', { method: 'GET' });
}

export async function refresh(): Promise<{ ok: true }> {
  return api('/auth/refresh', { method: 'POST' });
}

// HM-380 cluster login PIN: lista operatori pubblica per griglia pre-login.
export type Operator = {
  id: string;
  username: string;
  displayName: string;
  initials: string;
  role: 'reception' | 'housekeeping' | 'owner' | 'admin';
};

export async function listOperators(hotelId?: string): Promise<{ operators: Operator[] }> {
  const qs = hotelId ? `?hotelId=${encodeURIComponent(hotelId)}` : '';
  return api(`/auth/operators${qs}`, { method: 'GET' });
}

// HM-381 cluster login PIN: login PIN-based con username 1-40 e PIN 4 cifre.
export type LoginPinInput = { username: string; pin: string; hotelId?: string };

export async function loginPin(input: LoginPinInput): Promise<{ ok: true; user: AuthUser }> {
  return api('/auth/login-pin', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}
